import React from 'react';

const LinkingPendingInquiryContext = React.createContext({});

export const useLinkingPendingInquiryContext = () => React.useContext(LinkingPendingInquiryContext);

export default LinkingPendingInquiryContext;
